module.exports = __webpack_public_path__ + "fonts/poppins-v15-latin-300.081c758.woff";